// @workflow assistant.approvals
import { EventBus, TASK_EVENTS } from '@/event-bus';
import { changedTasksOf } from '@Assistant/domain/changedRecords';

/**
 * The assistant's one receiver for what a confirmed write changed (AVA-755). Called with every LIVE event of a
 * reply (assistant.modules.js startRun), never with a history replay, so opening an old conversation refreshes
 * nothing. The stream client already drops a replayed event (its per-run seq), so each change is announced once.
 * It announces through the app's event bus; the screens decide what they show (Task/views/index.vue).
 *
 * @param {object} event an assistant event
 */
export function announceChanges(event) {
  const tasks = changedTasksOf(event);
  if (tasks.length > 0) EventBus.$emit(TASK_EVENTS.CHANGED, { tasks });
}
